import React from 'react'
import { Link } from 'react-router-dom'
import { FiChevronRight } from 'react-icons/fi'

export default function BranchBreadcrumb({ items }) {
  return (
    <div className='branch-breadcrumb'>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && <FiChevronRight className='separator' size={14} />}
          {item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : (
            <span className='current'>{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}
